"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.isHTMLElement = exports.isComponent = void 0;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isComponent(arg) {
    return !!arg && typeof arg.render === 'function';
}
exports.isComponent = isComponent;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isHTMLElement(arg) {
    return !!arg && typeof arg.getBoundingClientRect === 'function';
}
exports.isHTMLElement = isHTMLElement;
//# sourceMappingURL=reflect.js.map